import { JetView } from "webix-jet";
import { checkedIcon, notCheckedIcon } from "../../helpers/icons";
import { roleAvatar } from "../../helpers/templates";

export default class RolesView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;
		const form = {
			view: "form",
			rows: [
				{
					rows: [
						{
							view: "template",
							localId: "title",
							borderless: true,
							height: 30,
							css: "webix_um_details_title",
							template: "#name#",
							data: { name: "" },
						},
						{
							cols: [
								{
									view: "template",
									localId: "number",
									borderless: true,
									css: "webix_um_details_title_description",
									template: v => {
										const number = v.roles ? v.roles.length : 0;
										let descr = !number
											? _("No roles")
											: `${_("Roles assigned")} (${number})`;
										return `<div class="webix_um_details_title_description">${descr}</div>`;
									},
									data: { name: "" },
								},
								{
									view: "toggle",
									localId: "toggle",
									offLabel: _("Modify"),
									onLabel: _("Done"),
									width: 160,
									on: {
										onChange: v => this.ToggleVisible(v),
									},
								},
							],
						},
					],
				},
			],
		};

		const table = {
			view: "datatable",
			localId: "roles",
			css: "webix_um_details_table",
			rowHeight: webix.skin.$active.rowHeight + 10,
			columns: [
				{
					id: "selected",
					hidden: true,
					header: "",
					width: 45,
					cssFormat: (_, obj) => (obj.selected ? "webix_um_row_select" : ""),
					template: obj => {
						return obj.selected ? checkedIcon : notCheckedIcon;
					},
				},
				{
					id: "name",
					header: {
						content: "textFilter",
						placeholder: _("Search"),
						prepare: a => a.toLowerCase(),
					},
					fillspace: 2,
					cssFormat: (_, obj) => (obj.selected ? "webix_um_row_select" : ""),
					template: role => {
						return roleAvatar(role) + role.name;
					},
				},
			],
			on: {
				onItemClick: id => this.Toggle(id.row * 1),
			},
		};

		return {
			type: "clean",
			rows: [
				{
					rows: [form, table],
				},
			],
		};
	}

	init() {
		this.$$("roles").registerFilter(
			this.$$("toggle"),
			{
				compare(_v1, _v2, obj) {
					return obj.selected;
				},
			},
			{
				getValue: a => (a.getValue() ? "" : true),
			}
		);
	}

	urlChange() {
		this.GetData();
	}

	GetData() {
		const local = this.app.getService("local");
		const id = this.getParam("id", true);
		this.ShowAll = false;

		return Promise.all([local.users(), local.roles()]).then(data => {
			this.User = webix.copy(data[0].getItem(id));
			this.User.roles = this.User.roles || [];
			const roles = data[1].serialize().map(({ id, name, color }) => ({
				id,
				color,
				name,
				selected: this.User.roles.indexOf(id) !== -1,
			}));
			this.$$("roles").parse(roles);
			this.$$("title").setValues(this.User);
			this.ShowNumber();
			this.Filter();
		});
	}

	Save() {
		this.User.roles = [];
		this.$$("roles").data.each(
			a => {
				if (a.selected) this.User.roles.push(a.id);
			},
			this,
			true
		);
		this.ShowNumber();
		this.app.getService("operations").updateUser(this.User.id, this.User);
	}

	ShowNumber() {
		this.$$("number").setValues(this.User);
	}

	ToggleVisible() {
		this.ShowAll = !this.ShowAll;

		if (this.ShowAll) this.$$("roles").showColumn("selected");
		else this.$$("roles").hideColumn("selected");

		this.Filter();
	}

	Toggle(id) {
		if (!this.ShowAll) return;
		const item = this.$$("roles").getItem(id);
		this.$$("roles").updateItem(id, { selected: !item.selected });
		this.Save();
	}

	Filter() {
		this.$$("roles").filterByAll();
		this.$$("roles").sort((a, b) =>
			a.selected == b.selected
				? a.name > b.name
					? 1
					: -1
				: a.selected
				? -1
				: 1
		);
	}
}
